module.exports = {"500241001":"中和街道","500241002":"乌杨街道","500241003":"平凯街道","500241004":"官庄街道","500241102":"清溪场镇","500241103":"隘口镇","500241104":"溶溪镇","500241106":"龙池镇","500241107":"石堤镇","500241108":"峨溶镇","500241109":"洪安镇","500241110":"雅江镇","500241111":"石耶镇","500241112":"梅江镇","500241113":"兰桥镇","500241114":"膏田镇","500241115":"溪口镇","500241116":"妙泉镇","500241117":"宋农镇","500241118":"里仁镇","500241119":"钟灵镇","500241201":"孝溪乡","500241207":"海洋乡","500241208":"大溪乡","500241211":"涌洞乡","500241214":"中平乡","500241215":"岑溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500241.json
// module id = 2250
// module chunks = 0